// extracted by mini-css-extract-plugin
export default {"admin_header":"styles_admin_header__uDe6+","wallet":"styles_wallet__Gn+NG"};